import Bestellung from "@/entities/common/bestellung"
import BstlArtikel from "@/entities/common/bstl_artikel"
import { Bezahlart, LoadState } from "@/entities/common/enums"
import BestellungPending, {
  Lieferung,
} from "@/entities/common/bestellung_pending"
import store from "@/store"
import Poster from "@/util/poster"
import RemoteResult from "@/entities/common/remote_result"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import router from "@/router"
import BPAufgebenRequest from "@/entities/common/pending/bp_aufgeben_request"
import Formatter from "../formatter"
import BaseLogic from "../base_logic"

export default class BestaetigenLieferungLogic extends BaseLogic {
  bestaetigenLoadState: string = LoadState.IDLE
  bestellung: Bestellung = null
  warenkorb: BstlArtikel[] = []
  bezahlart: string = null
  agbBestaetigt: boolean = false

  lieferungData: Lieferung = null

  init() {
    this.assignValues()
    this.mainLogic.bestellungPendingListeners.push(() => {
      this.assignValues()
    })
  }

  assignValues() {
    var nbd = this.mainLogic.bestellungPending
    this.bezahlart = nbd.bezahlart

    this.warenkorb = nbd.artikelliste
    this.lieferungData = nbd.lieferung
  }

  agbAnzeigen() {}

  berechneGesamtpreis(): number {
    var artikellistepreis = Formatter.berechnePreisListe(this.warenkorb)
    var lieferkosten = this.lieferungData.lieferkosten
    if (!lieferkosten) lieferkosten = 0
    return artikellistepreis + lieferkosten
  }

  bestellungBestaetigen() {
    if (this.bezahlart == Bezahlart.PAYPAL) {
      router.push({ name: RouteNames.NEU.TRINKGELD })
      return
    }

    this.bestaetigenLoadState = LoadState.LOADING

    var request = new BPAufgebenRequest()
    request.bestellungId = store.state.user.identifier
    request.bezahlart = this.bezahlart

    Poster.postUser<RemoteResult<Bestellung>>(
      RestPaths.bestellungpendingAufgeben,
      request
    )
      .then((response) => {
        if (response.data.success) {
          var dto = response.data.payload

          this.mainLogic.bestellung = dto
          this.mainLogic.bestellungPending = new BestellungPending()
          this.mainLogic.neueBestellung = false

          if (dto.bezahlart == Bezahlart.PAYPAL) {
            router.push({
              name: RouteNames.NEU.TRINKGELD,
            })
            return
          }

          router.push({
            name: RouteNames.BESTELLUNG_PAGE.DETAILS,
            params: { bestellungId: dto.id },
          })
        } else {
          this.bestaetigenLoadState = LoadState.ERROR
        }
      })
      .catch(() => {
        this.bestaetigenLoadState = LoadState.ERROR
      })
  }
}
